import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Image,
  useToast,
  Input,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { AddIcon } from "../Icons/AddIcon";
import { getImage } from "../../utils/helper";

export const StaticUploadImage = ({
  label,
  labelProps,
  imageUrl,
  parentCallback,
  name = "image",
  maxSize = 5,
  maxWidth = 600,
  maxHeight = 400,
  boxSize = '',
  display = "block",
  isRequired = false,
  isDisabled = false,
  mediaUrl = "" 
}) => {
  const [src, setSrc] = useState("");
  const fileRef = useRef();
  const toast = useToast();
  useEffect(() => {
    async function fetchData() {
      if(imageUrl instanceof File) {
        const img = await getImage(imageUrl, maxWidth, maxHeight);
        setSrc(img.src);
      } else {
        setSrc(imageUrl);
      }
    }
    fetchData();
  }, [imageUrl]);
  const openFileExplorer = () => {
    fileRef && fileRef.current && fileRef.current.click();
  };
  const handleFileChange = async (e) => {
    const file = e.target && e.target.files && e.target.files[0];
    if (!file) {
      toast({
        position: "top-right",
        title: `File not provided.`,
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      return true
    }
    if (file?.size / 1024 / 1024 >= maxSize) {
      toast({
        position: "top-right",
        title: `File size should not exceed ${maxSize}MB.`,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return true
    }
    try {
      const img = await getImage(file, maxWidth, maxHeight);
      setSrc(img.src);
      parentCallback(file);
    } catch (e) {
      toast({
        position: "top-right",
        title: e,
        status: "error",
        duration: 4000,
        isClosable: true
      });
    }
  };
  return (
    <FormControl 
      padding={{ base: "0" }} 
      colorScheme="brand" 
      width="unset" 
      display={display} 
      isRequired={isRequired}
      isDisabled={isDisabled}
    >
      <Box width="200px">
        <FormLabel {...labelProps}>{label}</FormLabel>
        {!!src || !!mediaUrl ? (
          <Box position="relative">
            <Input
              ref={fileRef}
              type="file"
              accept="image/png, image/jpeg"
              onChange={handleFileChange}
              name={name}
              position="absolute"
              top="0"
              left="0"
              width="100%"
              height="100%"
              opacity="0"
              padding="0 !important"
              cursor="pointer"
              isRequired={false}
            />
            <Button
              onClick={openFileExplorer}
              background="transparent"
              position="absolute"
              right="0px"
              top="-40px"
              padding="0"
              margin="0"
              color="#2b6cb0"
              textDecoration="underline"
              _hover={{ bg: "transparent" }}
            >
              Edit
            </Button>
            <Box width={boxSize} height="auto" overflow="hidden" >
              <Image
                src={src || mediaUrl}
                width="150px"
                objectFit='cover'
              />
            </Box>
          </Box>
        ) : (
          <Box
            w="200px"
            h="40px"
            background="#edf2f7"
            borderRadius="4px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
          >
            <Input
              ref={fileRef}
              type="file"
              accept="image/png, image/jpeg"
              onChange={handleFileChange}
              name={name}
              isRequired={isRequired}
              position="absolute"
              top="0"
              left="0"
              width="100%"
              height="100%"
              padding="0 !important"
              opacity="0"
            />
            <AddIcon />
          </Box>
        )}
      </Box>
    </FormControl>
  );
};
